import { type HandleResponseReturn, handleResponse, request } from "@/hooks/request";
import type { Competency } from "@/types/competency";

const CompetencyApi = (() => {
  const base_url = "/api/competency";
  return {
    fetchOne: (
      competency_id: string,
      abort_signal?: AbortSignal,
    ): Promise<HandleResponseReturn<Competency>> => {
      return request(`${base_url}/${competency_id}`, {
        signal: abort_signal,
      }).then(handleResponse<Competency>);
    },

    fetchAll: (
      competency_slugs: string[] = [],
      abort_signal?: AbortSignal,
    ): Promise<HandleResponseReturn<Competency[]>> => {
      const url = new URL(base_url, window.location.origin);
      if (competency_slugs.length > 0) {
        url.searchParams.set("slugs", competency_slugs.join(","));
      }
      return request(url.toString(), {
        signal: abort_signal,
      }).then(handleResponse<Competency[]>);
    },

    save: ({
      competency_id,
      data,
      abort_signal,
    }: {
      competency_id: string | null;
      data: any;
      abort_signal?: AbortSignal;
    }): Promise<HandleResponseReturn<Competency>> => {
      let url = base_url;
      if (competency_id) {
        url = `${url}/${competency_id}`;
      }
      return request(url, {
        signal: abort_signal,
        method: "post",
        body: JSON.stringify(data),
      }).then(handleResponse<Competency>);
    },
  };
})();

export default CompetencyApi;
